








import Component from 'vue-class-component';
import {VModel} from 'vue-property-decorator';
import {CustomerFormModel} from '@/context/customer/model/CustomerFormModel';
import Vue from 'vue';
import TextField from '@/general/component/TextField.vue';
import DLIdentifierAutcomplete
  from "@/context/remote_configuration/components/DataLoggerIdentifierAutocomplete.vue";
import {AnomalyRemovalFormModel} from "@/context/calculation/model/AnomalyRemovalFormModel";
import {UploadFormModel} from "@/context/remote_configuration/model/UploadFormModel";
import DataLoggerConfigurationAutocomplete
  from "@/context/remote_configuration/components/DataLoggerConfigurationAutocomplete.vue";
import {DownloadFormModel} from "@/context/remote_configuration/model/DownloadFormModel";

@Component({
  components: {DataLoggerConfigurationAutocomplete, DLIdentifierAutcomplete, TextField}
})
export default class RemoteConfigurationDownloadFormTemplate extends Vue {
  @VModel() model!: DownloadFormModel;
  valid: boolean = true;

  get rules(): Record<string, unknown> {
    return {};
  }
}
